import type { BillingEstimate, BillingEstimateParams } from '@recruitee/billing-estimate-types';
import type { PickActions } from '@recruitee/ngrx';
import { createSingleEntityStore, pipeState } from '@recruitee/ngrx';

const { actions, namespace, reducer, selectors } = createSingleEntityStore<BillingEstimate>()(
  'BillingEstimate',
  {
    customActions: adapter => ({
      fetch: (state, payload: BillingEstimateParams) =>
        pipeState(adapter.reset(), next => adapter.markAsPending(next)),
    }),
  },
);

const BillingEstimateActions: PickActions<typeof actions, 'fetch'> = actions;

export {
  BillingEstimateActions,
  namespace as BillingEstimateNamespace,
  reducer as BillingEstimateReducer,
  selectors as BillingEstimateSelectors,
};
